import { DomainError } from "@fideus/domain-error";
import type { StateCode } from "../federalStates";

export class InvalidTaxIdLengthError extends DomainError {
  readonly code = "INVALID_TAX_ID_LENGTH";
  public readonly state: StateCode;
  public readonly expectedLength: number;

  constructor(state: StateCode, expectedLength: number) {
    super("validation.taxId.invalidLength", { state, expectedLength }, 400);
    this.state = state;
    this.expectedLength = expectedLength;
  }
}
